// extracted by mini-css-extract-plugin
export default {"status":"Mission_status__onlgL","reserved":"Mission_reserved__UwpLG"};